import React from "react";
import { Handle, Position } from "reactflow";

import "./IntegrationIntentNode.scss";
import IntegrationHeader from "./IntegrationHeader";
import { useFlowNodes } from "../../../../../context";

const IntegrationIntentNode = () => {
  const { id, t } = useFlowNodes();

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="entry-node-container">
        <IntegrationHeader
          title={t("common:intents.flow_chat.integrations.title")}
        />
      </div>
    </>
  );
};

export default IntegrationIntentNode;
